import { render } from "./PropertiesSidebarV2.vue?vue&type=template&id=7e228421&scoped=true"
import script from "./PropertiesSidebarV2.vue?vue&type=script&lang=js"
export * from "./PropertiesSidebarV2.vue?vue&type=script&lang=js"

import "./PropertiesSidebarV2.vue?vue&type=style&index=0&id=7e228421&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e228421"]])

export default __exports__